import { createSlice } from "@reduxjs/toolkit";

import { fetchTimelineData } from "../thunks/timeline";

import type { JobTimelineData } from "../../utils/types/timeline";

interface TimelineState {
  jobsList: JobTimelineData[];
  loading: boolean;
  error: string | null;
  total: number;
  page: number;
  pageSize: number;
}

const initialState: TimelineState = {
  jobsList: [],
  loading: false,
  error: null,
  total: 0,
  page: 0,
  pageSize: 50,
};

export const timelineSlice = createSlice({
  name: "timeline",
  initialState,
  reducers: {
    resetStore: (state) => {
      state.jobsList = [];
      state.error = null;
      state.total = 0;
      state.page = 0;
      state.pageSize = 50;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTimelineData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTimelineData.fulfilled, (state, action) => {
        const { data, total, page } = action.payload;

        if (page > 1) {
          state.jobsList = [...state.jobsList, ...data];
        } else {
          state.jobsList = data;
        }

        state.total = total;
        state.page = page;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchTimelineData.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
  },
});

export const { resetStore } = timelineSlice.actions;
export default timelineSlice.reducer;
